import { internal } from './internal';
import { ui } from './ui';
import { v20 } from './v20';

export default {
  api: {
    internal,
    v20,
  },
  ui,
  external: {
    gettingStarted: 'https://confluence.atlassian.com/x/cGsSMw',
    lfsInfo: 'https://confluence.atlassian.com/x/RDRmMQ',
  },
};
